import "../styles/Footer.css";
import { FaLinkedinIn, FaInstagram } from "react-icons/fa";
import logo from "../assets/GBLogo3_Blanco.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Columna 1: Logo + Contacto */}
        <div className="footer-column logo-column">
          <img src={logo} alt="García Borreguero Logo" className="footer-logo" />
          <p>Calle Serrano 93 Planta 2º, Madrid</p>
          <p>Tel: +34 666 002 461</p>
          <p>Email: info@garciaborreguero.com</p>
        </div>

        {/* Columna 2: Enlaces */}
        <div className="footer-column">
          <h3>Enlaces útiles</h3>
          <ul>
            <li><a href="#hero">Inicio</a></li>
            <li><a href="#features">Resumen</a></li>
            <li><a href="#contact">Contacto</a></li>
          </ul>
        </div>

        {/* Columna 3: Redes sociales */}
        <div className="footer-column">
          <h3>Síguenos</h3>
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/garc%C3%ADa-borreguero-inversiones-inmobiliarias/" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
            <a href="https://www.instagram.com/garcia_borreguero?igsh=MXhudWN4eW9qeHN4-MA%3D%3D&utm_source=qr/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} García Borreguero. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
}